import api from './api';

export const bannerService = {
  getAdminBanners: async () => {
    const response = await api.get('/banners/admin/all');
    return response.data;
  },

  createBanner: async (bannerData) => {
    const response = await api.post('/banners', bannerData);
    return response.data;
  },

  toggleBannerActive: async (id) => {
    const response = await api.put(`/banners/${id}/toggle`);
    return response.data;
  },

  deleteBanner: async (id) => {
    const response = await api.delete(`/banners/${id}`);
    return response.data;
  },
};
